module.exports = __webpack_public_path__ + "static/media/quanfene61.57704775.png";